import { Injectable } from '@angular/core';

import { firstValueFrom } from 'rxjs';

import { UserService } from 'dspx-core';

import { API_ENDPOINTS } from '../constants/api-endpoints.constants';

import { LoggedInUserProfile } from '../interfaces/logged-in-user-profile.interface';

@Injectable({
  providedIn: 'root'
})
export class AsyncUserService {

  constructor(
    private userService: UserService) {

    this.userService.endpoints = {
      getLoggedInUser: API_ENDPOINTS.userAuthentication.getLoggedInUser,
    };
  }

  async getLoggedInUserProfile(): Promise<LoggedInUserProfile> {
    const loggedInUserProfile = await firstValueFrom(this.userService.getLoggedInUser('getLoggedInUser'));
    return <LoggedInUserProfile><unknown>loggedInUserProfile;
  }

  async getLoggedInUserProfileOrRedirect(): Promise<LoggedInUserProfile> {
    let loggedInUserProfile: LoggedInUserProfile;
    try {
      loggedInUserProfile = await this.getLoggedInUserProfile();
    }
    catch (e) {
      if (e.status === 401) {
        window.location.href = API_ENDPOINTS.authentication.signIn;
      }
    }
    return loggedInUserProfile;
  }
}
